// src/pages/auth/OAuthCallbackPage.jsx
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const OAuthCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const { refreshMe } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = searchParams.get('access_token');
    const oauthError = searchParams.get('oauth_error');

    if (oauthError) {
      navigate(`/login?oauth_error=${encodeURIComponent(oauthError)}`);
      return;
    }

    if (!accessToken) {
      navigate('/login?oauth_error=No+token+received');
      return;
    }

    // Store token exactly as the rest of the app does
    localStorage.setItem('accessToken', accessToken);
    sessionStorage.setItem('accessToken', accessToken);

    // Load user profile then redirect
    refreshMe(true).then((me) => {
      if (me) {
        navigate('/competitions');
      } else {
        navigate('/login?oauth_error=Failed+to+load+profile');
      }
    });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-raisin-black">
      <p className="text-swan/50 text-sm">Signing you in...</p>
    </div>
  );
};

export default OAuthCallbackPage;